export type CybersourceFormData = {
  access_key?: string;
  amount?: string;
  currency?: string;
  locale?: string;
  profile_id?: string;
  reference_number?: string;
  signature?: string;
  signed_date_time?: string;
  signed_field_names?: string;
  transaction_type?: string;
  transaction_uuid?: string;
  unsigned_field_names?: string;
  bill_to_forename?: string;
  bill_to_surname?: string;
  bill_to_address_country?: string;
  bill_to_address_line1?: string;
  bill_to_address_postal_code?: string;
  bill_to_address_city?: string;
  bill_to_address_state?: string;
  bill_to_company_name?: string;
};

export type MerchantConfig = {
  profileId: string;
  publicKey: string;
  privateKeySecretName: string;
};

export type PaymentData = {
  paymentType: string;
  referenceNumber: string;
  creditCardToken: string;
  creditCardNumber: string;
  creditCardExpiryDate: string;
  creditCardType: string;
};

export type CybersourcePaymentTokenResponse = {
  paymentMethodId: string;
};

export type CybersourcePaymentTokenResult = {
  referenceNumber?: string;
  success?: boolean;
  errorMessage?: string;
};

export enum Currency {
  USD = 'USD',
}

export enum PaymentType {
  CC = 'CC',
  ACH = 'ACH',
}

export const CYBERSOURCE_SUBMIT_MESSAGE_TYPE = 'cybersourcePaymentSubmitCallback';
export const CYBERSOURCE_CANCEL_MESSAGE_TYPE = 'cybersourceCancelCallback';
